import * as React from "react";
import {useSelector} from "react-redux";
import {Checkbox, Grid, InputAdornment, TextField, Typography} from "@material-ui/core";
import {Field, useFormikContext} from "formik";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import {Label} from "../../formInputs";
import {
    DatePicker,
    ErrorHelper as ErrorCommon,
    EstimationErrorCommon,
    NumberTextField,
    PhoneNumberField,
    SelectField,
    TextFieldCommon,
} from "../../formikFormInputs";
import {AccountType, genderDropDown, OTHER_VALUE} from "../../../constants";
import {addSuffix} from "../../../pages/client/Kids/util";
import {healthDropdownOtpions} from "../../../pages/client/Enrollment/allianzAppHome/basicInfo/PersonalDetailUtils";
import RenderDistribution from "../../../pages/client/Estimation/V1/Components/RenderDistribution";
import {FinancialDependentQuestion} from "./index";
import {RootState} from "../../../reducers";
import {useActions} from "../../../actions";
import * as EstimationActions from "../../../actions/estimation";
import {calculateAge} from "../../../pages/clientServicing/utils";
import {asDbDateFormat, DATE_FORMAT_DOB_SAVE} from "../../../utils/dateUtils";


type Relation = { id: string, name: string, value: string };

export default function Gen2ContactDetail({childNo, role}: {
    childNo?: number | string;
    role?: number,
}) {
    const {
        setFieldValue,
        values,
        handleChange,
        handleBlur,
        errors,
    } = useFormikContext<any>();

    const relationObj: Relation[] = [
        {
            id: "Mother",
            name: "Mother",
            value: "Mother",
        },
        {
            id: "Father",
            name: "Father",
            value: "Father",
        },
        {
            id: "Grandmother",
            name: "Grand Mother",
            value: "Grandmother",
        },
        {
            id: "Grandfather",
            name: "Grand Father",
            value: "Grandfather",
        },
        {
            id: "Other",
            name: "Other",
            value: "Other",
        },
    ];
    let formNames = addSuffix(childNo && childNo.toString());
    const otherRelation = {
        className: "mt20 TextFieldWidth",
        component: TextField,
        id: formNames.otherRelation,
        label: <Label label={"Other Relation"} required={true}/>,
        name: formNames.otherRelation,
        placeholder: "Other Relation",
        variant: "outlined",
        include: true
    };

    const fieldObj: any[] = [
        {
            className: "mt20",
            component: TextField,
            id: formNames.firstName,
            label: <Label label={"First Name"} required={true}/>,
            name: formNames.firstName,
            placeholder: "First Name",
            variant: "outlined",
            include: true
        },
        {
            className: "mt20",
            component: TextField,
            id: formNames.lastName,
            label: <Label label={"Last Name"} required={role !== AccountType.Agent}/>,
            name: formNames.lastName,
            placeholder: "Last Name",
            variant: "outlined",
            include: true
        },
        {
            className: "mt20",
            component: PhoneNumberField,
            id: formNames.phoneNumber,
            label: <Label label={"Cell Number"} required={true}/>,
            name: formNames.phoneNumber,
            placeholder: "Cell Number",
            variant: "outlined",
            include: true
        },
        {
            className: "mt20",
            component: TextField,
            id: formNames.email,
            label: <Label label={"Email Address"} required={true}/>,
            name: formNames.email,
            placeholder: "Email",
            variant: "outlined",
            include: true
        },
        {
            className: "mt20",
            component: DatePicker,
            disableFuture: true,
            id: formNames.dateOfBirth,
            label: <Label label={"Date of Birth"} required={true}/>,
            name: formNames.dateOfBirth,
            variant: "outlined",
            include: values[formNames.includeIllustration]
        },
        {
            className: "mt20",
            component: SelectField,
            id: formNames.gender,
            label: <Label label={"Gender"} required={true}/>,
            name: formNames.gender,
            options: genderDropDown,
            variant: "outlined",
            include: values[formNames.includeIllustration]
        },
        {
            className: "mt20",
            component: NumberTextField,
            id: formNames.contributionAmount,
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon" position="start">$</InputAdornment>,
            },
            label: <Label label={"Expected Contribution Amount For This Gift"} required={true}/>,
            name: formNames.contributionAmount,
            placeholder: "Expected Contribution Amount For This Gift",
            variant: "outlined",
            include: values && values.includeIllustration
        },
        {
            className: "mt20",
            component: SelectField,
            key: values[formNames.healthType],
            id: formNames.healthType,
            label: <Label label={"Health"} required={true}/>,
            name: formNames.healthType,
            options: healthDropdownOtpions,
            include: values[formNames.includeIllustration]
        },
        {
            className: "mt20",
            component: SelectField,
            id: formNames.relationToGen2Client,
            key: values[formNames.relationToGen2Client],
            label: <Label label="Relationship to Recipient" required={true}/>,
            name: formNames.relationToGen2Client,
            onSelectChange: (rel: string) => {
                if (rel === OTHER_VALUE) {
                    setFieldValue(formNames.otherRelation, '');
                }
            },
            options: relationObj,
            placeholder: "Relationship to Recipient",
            include: true
        },

    ];
    if (values && values[formNames.relationToGen2Client] === OTHER_VALUE) {
        fieldObj.push(otherRelation);
    }

    const childUnder18 = fieldObj.some((field) => {
        if (field.name.startsWith("dateOfBirth") && values[field.name]) {
            const age = calculateAge(values[field.name]);
            return age !== null && age >= 18;
        }
        return false;
    });
    
    return (
            <>
                <Grid container spacing={3}>
                    {
                            role === AccountType.Agent &&
                            <Grid item xs={12} sm={12} md={12} lg={12} key={0}>
                                <FormControlLabel
                                        className="mt10 mb0 pb0 ml0"
                                        labelPlacement="start"
                                        control={
                                            <Checkbox
                                                    className="mb0 pb0"
                                                    name="includeIllustration"
                                                    color="primary"
                                                    checked={values[formNames.includeIllustration]}
                                                    onChange={() => {
                                                        setFieldValue(formNames.dateOfBirth, null);
                                                        setFieldValue(formNames.includeIllustration, !values[formNames.includeIllustration]);
                                                    }}/>
                                        }
                                        label={(
                                                <Typography variant="body1" className="mt5 mb0 pb0">
                                                    Include illustration?
                                                </Typography>
                                        )}
                                />
                            </Grid>

                    }

                    {
                        fieldObj.map((field, index) => {
                            if (field.include) {
                                return (
                                        <React.Fragment key={index}>
                                            <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={6}
                                                    key={index}
                                            >
                                                <TextFieldCommon
                                                        values={values}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        InputLabelProps={{shrink: true}}
                                                        {...field}
                                                />
                                                <ErrorCommon
                                                        errors={errors}
                                                        name={field.name}
                                                />
                                            </Grid>
                                        </React.Fragment>
                                );
                            }
                        })
                    }
                </Grid>
                {
                        values && values[formNames.includeIllustration] &&
                        <>
                            <Gen2RenderDistribution
                                    childNo={childNo}
                                    dateOfBirth={values[formNames.dateOfBirth]}
                            />
                            <Gen2TobaccoQuestions childNo={childNo}/>
                        </>
                }
                {
                        childUnder18 &&
                        <FinancialDependentQuestion childNo={childNo}/>
                }
            </>
    );

}

export function Gen2RenderDistribution({childNo, dateOfBirth}: {
    childNo?: number | string,
    dateOfBirth: string
}) {
    const {user: {client}} = useSelector((state: RootState) => state.auth);
    const clientPolicy = client && client.clientPolicies && client.clientPolicies.length > 0 && client.clientPolicies[0];
    const carrierId = clientPolicy && clientPolicy.carrier ? clientPolicy.carrier.id : 2;
    const [issueAge, setIssueAge] = React.useState<number | null>(null);
    let formNames = addSuffix(childNo && childNo.toString());
    const distributionsLabel = "What ages would you like the Recipient to receive the distributions ?";

    return (
            <>
                <Grid item xs={12} md={12}>
                    <Grid container spacing={2} justify="center">
                        <Grid item xs={12}>
                            <Typography className="mt20 mb0 floatLeft w100" variant="body1" component="strong">
                                {distributionsLabel}
                            </Typography>
                        </Grid>
                        <IssueAgeCalculator carrierId={carrierId} dateOfBirth={dateOfBirth} issueAge={issueAge}
                                            setIssueAge={setIssueAge}/>
                        <RenderDistribution
                                fieldsNames={
                                    {
                                        "beginDistributions": formNames.beginDistributions,
                                        "endDistributions": formNames.endDistributions,
                                    }
                                }
                                issueAge={issueAge as number}
                                showTitle={false}
                                editMode={true}
                                carrierId={carrierId}
                        />
                    </Grid>
                </Grid>
            </>
    );
}


interface IIssueAgeCalculator {
    carrierId?: number;
    dateOfBirth: string;
    issueAge: number | null;
    setIssueAge: (issueAge: number) => void;
}

const IssueAgeCalculator = ({carrierId, dateOfBirth, issueAge, setIssueAge}: IIssueAgeCalculator) => {
    const {user, user: {client}} = useSelector((state: RootState) => state.auth);
    const clientPolicy: any = client && client.clientPolicies && client.clientPolicies.length > 0 && client.clientPolicies[0];
    if (!carrierId) {
        carrierId = clientPolicy && clientPolicy.carrierId;
    }
    const estimationActions = useActions(EstimationActions);

    const getIssueAge = async (dateOfBirth: string, carrierId: number) => {
        const dob: any = asDbDateFormat(dateOfBirth, DATE_FORMAT_DOB_SAVE);
        const response: any = await estimationActions.getIssueAge(dob, carrierId);
        return response && response.issueAge;
    }
    React.useEffect(() => {
        getIssueAge(dateOfBirth, carrierId as number).then(
                (issueAge: number) => {
                    setIssueAge(issueAge);
                }
        )
    }, [carrierId, dateOfBirth]);
    return <></>;
};

export function Gen2TobaccoQuestions(props: any) {
    const {childNo} = props;
    const {values, errors, touched, handleChange}: any = useFormikContext();
    let fieldLabel = "Does the Recipient use Tobacco or Marijuana products?";
    let labelOne = "Yes";
    let labelTwo = "No";
    const formNames = addSuffix(childNo && childNo.toString());

    return (
            <Grid item xs={12} className="mb15">
                <Typography variant="body1" component="strong" className="mb15 floatLeft w100 f18Sm">
                    {fieldLabel} <sup className="colorRed">*</sup>
                </Typography>

                <RadioGroup
                        className="floatLeft w100"
                        name={formNames.tobacco} row value={values.tobacco}
                        onChange={(e) => handleChange(e)}
                >
                    <FormControlLabel
                            style={{display: "inline", marginBottom: 0}}
                            value="used"
                            control={<Field as={Radio} name={formNames.tobacco}/>}
                            label={
                                <Typography variant="caption">{labelOne}</Typography>
                            }
                    />
                    <FormControlLabel
                            style={{display: "inline", marginBottom: 0}}
                            value="notUsed"
                            name={formNames.tobacco}
                            control={<Field as={Radio} name={formNames.tobacco}/>}
                            label={
                                <Typography variant="caption">{labelTwo}</Typography>
                            }
                    />
                    <span style={{width: "100%", float: "left"}}>
                        <EstimationErrorCommon
                                errors={errors}
                                name={formNames.tobacco}
                                touched={touched}
                        />
                    </span>
                </RadioGroup>
            </Grid>
    );
}